import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { LoggedUser } from "./logged-user.model";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { HttpClient } from "@angular/common/http";
// import { Transaction } from '../models/transaction.model';
// const BACKEND_URL = environment.apiUrl;
import { Translations } from "../localization/translations.service";
import { TranslateService } from "@ngx-translate/core";
const WEBAPI_URL = environment.webapiURL;
const jwt = new JwtHelperService();

@Injectable({ providedIn: "root" })
export class AuthService {
  private tokenTimer: any;
  private loggedUser: LoggedUser;
  private loggedUserUpdated = new Subject<LoggedUser>();
  private errosUpdated = new Subject<any>();
  private expiresIn: number;
  private acceptDateUpdated = new Subject<boolean>();
  private loginLoadingUpdated = new BehaviorSubject<boolean>(false);
  
  constructor(
    private http: HttpClient,
    private router: Router,
    private _snackBar: MatSnackBar,
    public t10s: Translations,
    public translateService: TranslateService
     ) {}

  login(authData): void {
    this.loginLoadingUpdated.next(true);
    this.http
      .post<{ 
        message: string;
        token: string;
        success: string;
        code?: string;
        expiresIn: number;
      }>(`${WEBAPI_URL}/auth/`, authData)
      .subscribe((response) => {
        
        if (response.success) {
          this.setToken(response.token);
          this.loginLoadingUpdated.next(false);
          this.router.navigate(["/dashboard"]);
          
          
        } else {
          this.loginLoadingUpdated.next(false);
          if (response.code === "MUST_CHANGE_PASSWORD") {
            // Primeiro acesso: backend bloqueia login e dispara e-mail de redefinição
            this.openSnackBar(response.message || "Primeiro acesso: verifique seu e-mail para redefinir a senha.", "x");
            return;
          }
          if  (response.message == "Usuário ou senha inválida"){
            this.openSnackBar(this.translateService.instant(this.t10s.LOGIN.LOGIN.invalidUserpwd), "x");
          }
          if  (response.message == "Email não encontrado"){
            this.openSnackBar(this.translateService.instant(this.t10s.LOGIN.LOGIN.invalidEmail), "x");
          }
                             
        }
      },
      (error)=> {
        this.loginLoadingUpdated.next(false);
        if (error && error.status === 504) {
          this.openSnackBar("Serviço indisponível no momento (timeout). Tente novamente em instantes.", "x");
          return;
        }
        this.openSnackBar(this.translateService.instant(this.t10s.LOGIN.LOGIN.error), "x");
        }
      );
  }

  

  reset(authData) {
    return this.http.post<{ message: string; success: string }>
    ( `${WEBAPI_URL}/auth/forgotpassword`, authData);
  }

  

  pwdAlter(authReset) { return this.http.post<{ message: string; success: string }>(
 `${WEBAPI_URL}/auth/resetpassword`, authReset);

  }
  
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, "x", {
      duration: 2000,
      verticalPosition: "top",
    });
  }

  getLoggedUserListener(): Observable<LoggedUser> {
    return this.loggedUserUpdated.asObservable();
  }

  getErrosListener(): Observable<any> {
    return this.errosUpdated.asObservable();
  }

  getLoginLoadingListener(): Observable<boolean> {
    return this.loginLoadingUpdated.asObservable();
  }

  updateLoggedUser(): void {
    this.loggedUserUpdated.next(this.loggedUser);
  }
  getLoggedUser(): LoggedUser {
    return this.loggedUser;
  }

  isInternalUser(user?: LoggedUser): boolean {
    const target = user || this.loggedUser;
    if (!target) return false;
    if (target.userId === 0) return true;
    if (target.is_internal === true || target.isInternal === true) return true;

    const hasAccessCode = !!target.access_code;
    const hasCustomerId = !!target.customer_id;
    return !hasAccessCode && !hasCustomerId;
  }

  autoLogin(): void {
    const rawToken = this.getToken();
    const token = jwt.decodeToken(rawToken);

    if (!token) {
      // this.logout();
      return;
    }

    if (jwt.isTokenExpired(rawToken)) {
      this.logout();
      return;
    }

    this.setToken(rawToken);
  }

  patchAcceptDate(): void {
    this.http
      .patch<{ message: string; token: string; success: string }>(
        `${WEBAPI_URL}/auth/acceptdate`,
        {}
      )
      .subscribe((response) => {
        if (!response.success) {
          return;
        }

        this.setToken(response.token);
        this.autoLogin();
        window.location.reload();
      });
  }
  getPatchAcceptDate(): Observable<boolean> {
    return this.acceptDateUpdated.asObservable();
  }

  logout(): void {
    this.loggedUser = null;
    this.loggedUserUpdated.next(this.loggedUser);
    clearTimeout(this.tokenTimer);
    this.expiresIn = null;
    this.clearToken();
    this.router.navigate(["/pages/home"]);
  }

  setToken(newToken: string): void {
    const token = jwt.decodeToken(newToken);
    this.expiresIn = token.exp * 1000 - new Date().getTime();
    this.saveToken(newToken);
    this.setTokenTimer(this.expiresIn);
    this.loggedUser = token.user;
    this.loggedUserUpdated.next(this.loggedUser);
    // this.putTransaction();
  }

  private setTokenTimer(expiresIn: number): void {
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, expiresIn);
  }

  public getExpiresIn(): number {
    return this.expiresIn;
  }

  private saveToken(token: string): void {
    localStorage.setItem("token", token);
  }

  public getToken(): string {
    return localStorage.getItem("token");
  }

  private clearToken(): void {
    localStorage.removeItem("token");
  }
}
